// @flow

import styled from 'styled-components'

const PageSubTitle = styled.h2`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 1.4;
`

export default PageSubTitle



// WEBPACK FOOTER //
// ./src/components/space/PageSubTitle.jsx